import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import Section from "../../components/section";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Plus from "../../components/svg/plus";
import Label from "../../components/label";
import Trash from "../../components/svg/trash";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";

export default function AddUser() {
  return (
    <div className="p-3 bg-[#fffbf4] ">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = usePageProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="30" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>SEO META</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col ">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="w-[100%] ml-[1rem]">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Primary Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_heading" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Secondery Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex flex-col mt-2">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="header.description" rootClassName="w-full" />
                  </div>
                  <FieldArray
                    name="banners"
                    render={(arrayHelpers) => (
                      <>
                        <div className="flex justify-end mb-1 mt-2">
                          <div
                            className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer"
                            onClick={() => {
                              arrayHelpers.push({
                                title: "",
                                description: "",
                                details: "",
                                icon: "",
                                desktop_image_url: "",
                                alt_tag: "",
                              });
                            }}
                          >
                            <Plus className="text-white" />
                          </div>
                        </div>

                        <div className="overflow-x-auto mt-4">
                          <table className="w-full border border-gray-300 text-sm table-fixed">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="w-[15.67%] border px-3 py-2 text-left">Heading</th>
                                <th className="w-[15.67%] border px-3 py-2 text-left">Description</th>
                                <th className="w-[15.67%] border px-3 py-2 text-left">CTA Label</th>
                                <th className="w-[15.67%] border px-3 py-2 text-left">CTA Redirect Link</th>
                                <th className="w-[15.67%] border px-3 py-2 text-left">Icon</th>
                                <th className="w-[15.67%] border px-3 py-2 text-left">Alt Tag</th>
                                <th className="w-[6%] border px-3 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values.banners.map((item, index) => (
                                <tr key={`banner-${index}`} className="align-top">
                                  <td className="border px-3 py-2">
                                    <FormikInput name={`banners.${index}.title`} rootClassName="w-full" />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <FormikTextarea name={`banners.${index}.description`} rootClassName="w-full" />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <FormikInput name={`banners.${index}.cta_label`} rootClassName="w-full" />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <FormikInput name={`banners.${index}.cta_redirect_link`} rootClassName="w-full" />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <ImageUploader
                                      title="Icon"
                                      imageUrl={item.icon}
                                      onChange={(res) => setFieldValue(`banners.${index}.icon`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <FormikInput name={`banners.${index}.alt_tag`} rootClassName="w-full" />
                                  </td>

                                  <td className="w-[6%] border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => arrayHelpers.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  />
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>One learning platform. Endless possibilities</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="learning_platform.title" rootClassName="w-full" />
                    </div>
                  </div>

                  <FieldArray name="learning_platform.add_ons">
                    {(arrayHelpers) => (
                      <div className="mt-6">
                        <div className="flex justify-between items-center mb-3">
                          <h3 className="text-lg font-medium">Add Images</h3>
                          <button
                            type="button"
                            className="bg-[#7C13CA] text-white p-2 rounded-full"
                            onClick={() => arrayHelpers.push({ image_url: "", alt_tag: "" })}
                          >
                            <Plus className="h-4 w-4" />
                          </button>
                        </div>

                        <div className="overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[80%] border font-normal border-gray-300 px-2 py-2 text-left">Image</th>
                                <th className="w-[80%] border font-normal border-gray-300 px-2 py-2 text-left">Alt Tag</th>
                                <th className="w-[10%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.learning_platform?.add_ons?.map((item, index) => (
                                <tr key={index}>
                                  <td className="w-[70%] border border-gray-300 px-4 py-2">
                                    <ImageUploader
                                      imgStyle={{ width: "8rem" }}
                                      title="Image"
                                      imageUrl={item?.image_url}
                                      onChange={(res) => setFieldValue(`learning_platform.add_ons.${index}.image_url`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="border px-2 py-2">
                                    <FormikInput name={`learning_platform.add_ons.${index}.alt_tag`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[20%] border border-gray-300 px-4 py-2">
                                    <div className="flex justify-center cursor-pointer" onClick={() => arrayHelpers.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
